//index

import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { getPosts, getUrlReglamento } from "../../service/apiBackEnd";
import styles from "../index.module.css"
import iconoAudiencia from "../../assets/icono_audiencia.png";
import iconoTarifario from "../../assets/icono_tarifario.png";
import iconoSolicitud from "../../assets/icono_solicitud.png";
import iconoPerforacion from "../../assets/icono_perforacion.png";
import iconoOperadores from "../../assets/icono_operadores.png";
import iconoObras from "../../assets/icono_obras.png";
import iconoInfo from "../../assets/icono_info.png";
import iconoReclamo from "../../assets/icono_reclamo.png";
import iconoCalidad from "../../assets/calidad.png";
import { ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";
const Inicio = () => {
    const [posts, setPosts] = useState([]);
    const [UrlReglamento, setUrlReglamento] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPosts = async () => {
            const data = await getPosts("&categories=23&per_page=3");
            setPosts(data);
        };
        fetchPosts();
        const fetchReglamento = async () => {
            const data = await getUrlReglamento();
            setUrlReglamento(data);
        };
        fetchReglamento();
    }, []);
    if (!posts || posts.length === 0) {
        return <div style={{ textAlign: "center", fontWeight: "600", color: "var(--primary-color)", fontSize: "2em" }}>Cargando...</div>;
    }
    const getUrl = UrlReglamento?.map(item => item.acf.archivo_reglamento);

    return (
        <>
            <div className={styles.mainBg} >
                <h1>Bienvenidos a DIRCAS</h1>
                <h5>Dirección de Regulación y Control de Agua y Saneamiento</h5>
            </div>
            <div className={styles.bgReclamos} style={{ display: "inline-flex", width: "100%", justifyContent: "center", gap: "2em", padding: "1em" }}>
                <div><a className={styles.btnReclamos}
                    href="https://reclamos.irrigacion.gov.ar/autogestion/web/site/login" target="_blank">
                    <h2>Reclamos</h2>
                </a></div>
                {/* <div>
                    <a 
                        href="https://reclamos.irrigacion.gov.ar/frontend/web/site/login" target="_blank">
                        <h4>Reclamo operadores</h4>
                    </a>
                </div> */}
            </div>
            <Container>

                <Row className="mb-5 mt-5">
                    <h1 className="mb-5" style={{ textAlign: "center", color: "var(--dark)" }}>Nuestros servicios</h1>
                    <Col lg={3} className={styles.servicios}>
                        <div><a href="/audienciaPublica">
                            <img src={iconoReclamo} className={styles.imgIconos}></img>
                            <h2>Audiencias Públicas</h2>
                        </a></div>
                    </Col>
                    <Col lg={3} className={styles.servicios}>
                        <div><a href="/sistemaTarifario">
                            <img src={iconoTarifario} className={styles.imgIconos}></img>
                            <h2>Sistema de facturación</h2>
                        </a></div>
                    </Col>
                    {/* <Col lg={4} className={styles.servicios}>
                        <div><a href="/informacionPublica">
                            <img src={iconoInfo} className={styles.imgIconos}></img>
                            <h2>Normas nacionales y provinciales</h2>
                        </a></div>
                    </Col> */}
                    <Col lg={3} className={styles.servicios}>
                        <div>
                            <a href="/operadores">
                                <img src={iconoOperadores} className={styles.imgIconos}></img>
                                <h2>Operadores</h2>
                            </a>
                        </div>
                    </Col>
                    {/* <Col lg={4} className={styles.servicios}>
                        <div>
                            <a href="/permisosPerforacion">
                                <img src={iconoPerforacion} className={styles.imgIconos}></img>
                                <h2>Factibilidades y Permisos de Perforación</h2>
                            </a>
                        </div>
                    </Col> */}
                    {/* <Col lg={4} className={styles.servicios}>
                        <div>
                            <a href="/resoluciones-regulatorias">
                                <img src={iconoCalidad} className={styles.imgIconos}></img>
                                <h2>Resoluciones regulatorias</h2>
                            </a>
                        </div>
                    </Col> 
                    <Col lg={4} className={styles.servicios}>
                        <div>
                            <a href={`${getUrl}`} target="_blank" >
                                <img src={iconoObras} className={styles.imgIconos}></img>
                                <h2>Reglamento del usuario</h2>
                            </a>
                        </div>
                    </Col>*/}

                    {/* <Col lg={4} className={styles.servicios}>
                        <div>
                            <a href="/solicitud" >
                                <img src={iconoSolicitud} className={styles.imgIconos}></img>
                                <h2>Solicitud Constitución Operador</h2>
                            </a>
                        </div>
                    </Col> */}

                    <Col lg={3} className={styles.servicios}>
                        <div>
                            <a href="/marco-regulatorio">
                                <img src={iconoAudiencia} className={styles.imgIconos}></img>
                                <h2>Marco regulatorio</h2>
                            </a>
                        </div>
                    </Col>
                    {/* <Col lg={4} className={styles.servicios}>
                        <div>
                            <a href="/reclamos">
                                <img src={iconoAudiencia} className={styles.imgIconos}></img>
                                <h2>Reclamos</h2>
                            </a>
                        </div>
                    </Col> */}
                </Row>
            </Container >
            <Container>
                <Row>
                    <h2 style={{ textAlign: "center", color: "var(--dark)", margin: "0" }}>Últimas noticias</h2>
                    {posts.filter((post) => console.log("DIRCAS", post) || post.categories.includes(23)).slice(0, 3).map((post) => {

                            const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
                            return (
                                <>
                                    <Col lg={4} md={6} sm={12} key={post.id}>
                                        <div className={styles.mainNoticias}>
                                            <a href={`/noticias/${post.id}`} key={post.id} >
                                                {featuredImage && <img src={featuredImage} alt={post.title.rendered} className={styles.mainImg} />}
                                                <h3>{post.title.rendered}</h3>
                                                <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}></p>
                                            </a>
                                        </div>
                                    </Col>
                                </>
                            );
                        })}
                    <br></br>
                    <Row>
                        <button onClick={() => navigate(ROUTES.noticias.path)}
                            className={styles.btnMasNoticias}
                        >Ver todas las noticias</button>
                    </Row>
                </Row>
            </Container >

        </ >
    );
};

export default Inicio;
